// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2Po4e","actions":"GroupTable_actions__S4ORN","deleteModalFooter":"GroupTable_deleteModalFooter__2MZYl"};